<app-banner [title]="'Inscription'" [links]="bannnerLinks"></app-banner>

<div class="container">
	@if (!otpId) {
	<app-verify-phone-number (otpRequested)="onOtpRequested($event)"></app-verify-phone-number>
	} @else {
	<div class="w-full py-10">
		<form [formGroup]="registrationForm">
			<div>
				<label class="required text-gray-700" for="sex">Sexe</label>
				<div class="flex items-center gap-8 mt-2">
					<div class="flex items-center gap-x-1">
						<input type="radio" name="sex" value="male" formControlName="sex"
							class="radio radio-sm border-gray-600 bg-white checked:!text-red-600 checked:!border-red-600" id="man">
						<label class="text-sm text-gray-700" for="man">Masculin</label>
					</div>
					<div class="flex items-center gap-x-1">
						<input type="radio" name="sex" value="female" formControlName="sex"
							class="radio radio-sm border-gray-600 bg-white checked:!text-red-600 checked:!border-red-600" id="woman">
						<label class="text-sm text-gray-700" for="woman">Féminin</label>
					</div>
				</div>
				@if (hasError('sex')) {
					<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('sex') }}</div>
				}
			</div>
			<div class="w-full bg-primary h-[1px] my-8"></div>
			<div class="flex flex-col gap-y-7">
				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="required text-gray-700" for="firstname">Prénom(s)</label>
						<input type="text" formControlName="firstname"
							[class]="getFieldClass('firstname')" id="firstname"
							placeholder="Prénom(s)" />
						@if (hasError('firstname')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('firstname') }}</div>
						}
					</div>
					<div>
						<label class="required text-gray-700" for="lastname">Nom</label>
						<input type="text" formControlName="lastname"
							[class]="getFieldClass('lastname')" id="lastname" placeholder="Nom" />
						@if (hasError('lastname')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('lastname') }}</div>
						}
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="required text-gray-700" for="phoneNumber">Mobile (identifiant)</label>
						<input type="text" [value]="phoneNumber" readonly
							class="input w-full mt-2 placeholder:text-gray-400 text-gray-600 bg-gray-100" id="phoneNumber"
							placeholder="Mobile (identifiant)" />
					</div>
					<div>
						<label class="required text-gray-700" for="adresse">Adresse</label>
						<input type="text" formControlName="address" [class]="getFieldClass('address')" id="adresse"
							placeholder="Adresse" />
						@if (hasError('address')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('address') }}</div>
						}
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="required text-gray-700" for="birthday">Date de naissance</label>
						<input type="date" formControlName="birthday" [class]="getFieldClass('birthday')" id="birthday"
							placeholder="Date de naissance" />
						@if (hasError('birthday')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('birthday') }}</div>
						}
					</div>
					<div>
						<label class="text-gray-700" for="email">Email</label>
						<input type="email" formControlName="email"
							[class]="getFieldClass('email')" id="email"
							placeholder="Adresse email (optionnel)" />
						@if (hasError('email')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('email') }}</div>
						}
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="text-gray-700" for="password">Mot de passe</label>
						<div class="relative mt-2">
							<input [type]="showPassword ? 'text' : 'password'" formControlName="password"
								[class]="getFieldClass('password') + ' pr-12'" id="password"
								placeholder="Mot de passe" />
							<button type="button" 
								class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
								(click)="togglePasswordVisibility()">
								@if (showPassword) {
									<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
									</svg>
								} @else {
									<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
									</svg>
								}
							</button>
						</div>
						@if (hasError('password')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('password') }}</div>
						}
					</div>
					<div>
						<label class="text-gray-700" for="confirmPassword">Confirmer le mot de passe</label>
						<div class="relative mt-2">
							<input [type]="showConfirmPassword ? 'text' : 'password'" formControlName="confirmPassword"
								[class]="getFieldClass('confirmPassword') + ' pr-12'" id="confirmPassword"
								placeholder="Confirmer le mot de passe" />
							<button type="button" 
								class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700 focus:outline-none"
								(click)="toggleConfirmPasswordVisibility()">
								@if (showConfirmPassword) {
									<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L3 3m6.878 6.878L21 21" />
									</svg>
								} @else {
									<svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
										<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
									</svg>
								}
							</button>
						</div>
						@if (hasError('confirmPassword')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('confirmPassword') }}</div>
						}
					</div>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="required text-gray-700" for="nationality">Nationalité</label>
						<select formControlName="nationality" [class]="getSelectClass('nationality')" id="nationality">
							<option value="">Sélectionner une nationalité</option>
							<option value="SN">Sénégalaise</option>
						</select>
						@if (hasError('nationality')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('nationality') }}</div>
						}
					</div>
					<div>
						<label class="required text-gray-700" for="country">Pays</label>
						<select formControlName="country" [class]="getSelectClass('country')" id="country">
							<option value="">Sélectionner un pays</option>
							@for (country of countries; track country.iso2) {
							<option value="{{ country.iso2 }}">{{ country.name }}</option>
							}
						</select>
						@if (hasError('country')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('country') }}</div>
						}
					</div>
				</div>

				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
					<div>
						<label class="required text-gray-700" for="region">Région</label>
						<select formControlName="region" [class]="getSelectClass('region')" id="region">
							<option value="">Sélectionner une région</option>
							@for (region of regions; track region.iso2) {
							<option value="{{ region.iso2 }}">{{ region.name }}</option>
							}
						</select>
						@if (hasError('region')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('region') }}</div>
						}
					</div>
					<div>
						<label class="required text-gray-700" for="commune">Commune</label>
						<select formControlName="commune" id="commune" [class]="getSelectClass('commune')">
							<option value="">Sélectionner une commune</option>
							@for (commune of communes; track commune.id) {
							<option value="{{ commune.name }}">{{ commune.name }}</option>
							}
						</select>
						@if (hasError('commune')) {
							<div class="text-red-500 text-sm mt-1">{{ getErrorMessage('commune') }}</div>
						}
					</div>
				</div>
				<div class="grid grid-cols-1 md:grid-cols-2 gap-7">
				</div>

				<div class="flex justify-end mt-8">
					<button type="submit" [disabled]="loading || registrationForm.invalid" class="btn btn-primary disabled:opacity-50" (click)="onSubmit()">
						@if (loading) {
						<span class="loading loading-spinner loading-sm"></span>
						}
						Créer le compte
					</button>
				</div>

				@if (error) {
				<div class="alert alert-error mt-4">
					<svg xmlns="http://www.w3.org/2000/svg" class="stroke-current shrink-0 h-6 w-6" fill="none"
						viewBox="0 0 24 24">
						<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
							d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z" />
					</svg>
					<span>{{ error }}</span>
				</div>
				}
			</div>

		</form>

	</div>
	}
</div>